import Draft from "draft-js";

export enum InlineStyles {
  Bold = "BOLD",
  Code = "CODE",
  Italic = "ITALIC",
  Link = "LINK",
  Underline = "UNDERLINE",
  StrikeThrough = "STRIKETHROUGH",
}

export const INLINE_STYLES: Draft.DraftStyleMap = {
  [InlineStyles.Bold]: { fontWeight: "bold" },
  [InlineStyles.Italic]: { fontStyle: "italic" },
  [InlineStyles.Code]: { font: "1rem/1rem monospace" },
  [InlineStyles.Link]: { color: "red" },
  [InlineStyles.Underline]: { textDecoration: "underline" },
  [InlineStyles.StrikeThrough]: { textDecoration: "line-through" },
};
